import styled from "styled-components"
import media from "styled-media-query"

const Comment = styled.div`
  height: auto;
  letter-spacing: 0.3px;
  line-height: 1.82em;
  padding: 0 0 4px 0;
  width: 100%;
  ${media.greaterThan("small")`
    height: 11em;
    letter-spacing: 0.5px;
    line-height: 1.7em;
  `}
  p {
    margin-bottom: 0;
  }
`
export default Comment
